import { StatusCodes } from "http-status-codes";
import { request } from "../api";
import { headers } from "../../../config/config";
import { MESSAGE } from "../../../constants/api/message";
import { AUTHORIZATION } from "../../../constants/api/auth";
import { CustomWaivedBenifitDetails } from "../../../@types/waivedBenifits.types";
import { Member } from "../../../@types/member.types";

const { get } = request;
const { Authorization, Bearer } = AUTHORIZATION;

const initialRoute = "member/enrollment";

export type WaivedBenifits = Omit<CustomWaivedBenifitDetails, "employee_name"> & { employee: Member };

export const getMemberWaivedBenefits = async (
	company: "nex" | "veb",
	group_number: number
): Promise<WaivedBenifits[]> => {
	try {
		const endpoint = `${initialRoute}/${company}/${group_number}/waive-report`;
		const token = localStorage.getItem("@jwt");
		const response = await get(endpoint, {
			...headers,
			[Authorization]: `${Bearer} ${token}`
		});
		if (response) {
			const {
				data: { message }
			} = response;
			if (message === MESSAGE.get.succ) {
				const {
					data: { result }
				} = response;
				return result;
			}
			throw new Error();
		}
		throw new Error();
	} catch (error: any) {
		if (error.response.status === StatusCodes.BAD_REQUEST) {
			const { message } = error.response.data;
			alert(message);
			throw message;
		} else if (error.response.status === StatusCodes.UNAUTHORIZED) {
			const { message } = error.response.data;
			alert(message);
			throw message;
		} else {
			throw error;
		}
	}
};
